import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import texts from './texts.json';
import { StyledPaper, StyledDialogContentText } from './styles';

const ConfirmDialog = ({
  isOpen,
  onConfirm,
  confirmDisabled,
  onCancel,
  dialogTexts,
  ...other
}) => (
  <Dialog
    open={isOpen}
    PaperComponent={StyledPaper}
    {...other}
  >
    <DialogTitle>
      {dialogTexts.title}
    </DialogTitle>
    <DialogContent>
      {isValidElement(dialogTexts.content)
        ? dialogTexts.content
        : (
          <StyledDialogContentText>
            {dialogTexts.content || ''}
          </StyledDialogContentText>
        )}
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onConfirm}
        color="success"
        disabled={confirmDisabled}
      >
        {dialogTexts.confirm || texts.confirm}
      </Button>
      {!!onCancel && (
        <Button
          onClick={onCancel}
          color="warning"
        >
          {dialogTexts.cancel || texts.cancel}
        </Button>
      )}
    </DialogActions>
  </Dialog>
);

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  confirmDisabled: PropTypes.bool,
  dialogTexts: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]),
    confirm: PropTypes.string,
    cancel: PropTypes.string,
  }).isRequired,
};

ConfirmDialog.defaultProps = {
  onCancel: null,
  confirmDisabled: false,
};

export default ConfirmDialog;
